import request from '../../utils/request';

export default async () => {
  const response = await request('/pre-settlement-requests');

  return response && response.length ? response.map((settlement) => {
    const { frequency = '' } = settlement;
    const requestType = settlement.requestType === 'IMMEDIATE' ? settlement.requestType : `${settlement.requestType} - ${frequency}`;
    let searchField;
    let searchFieldId;
    if (settlement.requestType === 'IMMEDIATE') {
      if (settlement.receptacleId) {
        searchField = 'Receptacle ID';
        searchFieldId = settlement.receptacleId;
      } else if (settlement.despatchId) {
        searchField = 'Despatch ID';
        searchFieldId = settlement.despatchId;
      } else if (settlement.consignmentId) {
        searchField = 'Consignment ID';
        searchFieldId = settlement.consignmentId;
      }
    }

    return {
      ...settlement,
      requestType,
      searchField,
      searchFieldId,
    };
  }) : response;
};
